import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c50b80be"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c50b80be')) {
      api.createRecord('c50b80be', component.options)
    } else {
      api.reload('c50b80be', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c50b80be", function () {
      api.rerender('c50b80be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/consign/intimidate/index.vue"
export default component.exports